<template>
  <!-- begin sidebar nav -->
  <ul class="nav" v-if="modules">
    <template v-for="menu in modules">
      <sidebar-nav-list ref="sidebarNavList" v-bind:menu="menu" v-bind:scrollTop="scrollTop" v-bind:key="menu.path" v-bind:status="menu.status" v-on:collapse-other="handleCollapseOther(menu)" v-on:showFloatSubmenu="handleShowFloatSubmenu" v-on:hideFloatSubmenu="handleHideFloatSubmenu"></sidebar-nav-list>
    </template>

    <!-- begin sidebar minify button -->
    <li>
      <a href="javascript:;" class="sidebar-minify-btn" v-on:click="handleSidebarMinify()"><i class="fa fa-angle-double-left"></i></a>
    </li>
    <!-- end sidebar minify button -->
  </ul>
  <!-- end sidebar nav -->
</template>

<script>
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions";

export default {
  name: "SidebarNav",
  props: ["scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      // menus: null,
      // mpmMenu : MPMSidebarMenu,
      pageOptions: PageOptions,
      modules: null,
    };
  },
  mounted() {
    this.getModules();
    // this.menus = eval("this." +this.$store.state.company.toLowerCase() + "Menu");
  },
  methods: {
    handleShowFloatSubmenu: function (menu, offset) {
      this.$emit("showFloatSubmenu", menu, offset);
    },
    handleHideFloatSubmenu: function () {
      this.$emit("hideFloatSubmenu");
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.modules.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    handleSidebarMinify: function () {
      this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
    },

    async getModules() {
      let userAccess = this.$store.getters.currentUser;

      let modules = this.$store.state.modules;

      // Safeguard if Modules Fail - Marv
      if (modules.length <= 0) modules = await this.loadModules();

      // console.log("modules", modules);

      // Remove Filter if Login is Super Admin ( Hasilnya Kosong kalau di filter ) - Marv
      if (userAccess.role == "SUPER ADMIN" || userAccess.role == "ADMIN") {
        // modules = JSON.parse(JSON.stringify(modules)).filter((x) => x.path && !x.path.includes("/dealer/"));
        modules = JSON.parse(JSON.stringify(modules)).filter((x) => x.dealer_access == (userAccess.role == 0));
        for (let i = 0; i < modules.length; i++) {
          const item = modules[i];
          if (item.children && Array.isArray(item.children)) {
            for (let j = 0; j < item.children.length; j++) {
              if (item.children[j].path == '/qr-code/distribution-monitoring-se') {
                item.children.splice(j, 1);
                j--;
              }
            }
          }
          modules[i] = item;
        }
      } else {
        modules = JSON.parse(JSON.stringify(modules)).filter((x) => x.dealer_access == (userAccess.role == "USER DEALER" ? 1 : 0));
      }

      var allowed_roles = ["SUPER ADMIN", "ADMIN"];

      if (allowed_roles.indexOf(userAccess.role) === -1) {
        let i = 0;
        while (modules[i]) {
          if (!modules[i].children) {
            if (userAccess.modules.map((x) => parseInt(x)).indexOf(modules[i].id) == -1) modules.splice(i, 1);
            else i++;
          } else {
            let j = 0;
            while (modules[i].children[j]) {
              if (userAccess.modules.map((x) => parseInt(x)).indexOf(modules[i].children[j].id) == -1) modules[i].children.splice(j, 1);
              else j++;
            }
            if (modules[i].children.length == 0) modules.splice(i, 1);
            else i++;
          }
        }
      }

      //Add title 'Dashboard' (Marv Changes , Checks whether title List already exist or not)
      if (!modules.find((x) => x.title == "Dashboard")) modules.splice(0, 0, { icon: "li", title: "Dashboard", is_show_sidebar: 1 });

      const normalizeTitle = (list) => {
        if (!list || !Array.isArray(list)) return;
        for (let k = 0; k < list.length; k++) {
          if (list[k].title === 'Penerimaan QR Dealer' || list[k].title === 'Penerimaan QR dealer') {
            list[k].title = 'Penerimaan QR';
          }
          if (list[k].children) {
            normalizeTitle(list[k].children);
          }
        }
      };
      normalizeTitle(modules);

      // Add 'Atur Jumlah Transfer QR' and 'Atur Akses Transfer Balik' for SUPER ADMIN, ADMIN, USER MAIN DEALER
      const isAllowedTransferMenu = ["SUPER ADMIN", "ADMIN", "USER MAIN DEALER"].includes(userAccess.role);
      if (isAllowedTransferMenu) {
        const qrMenu = modules.find((x) => x.path === "/qr-code" || (x.title && x.title.toLowerCase() === "qr codes"));
        if (qrMenu) {
          if (!qrMenu.children) qrMenu.children = [];
          if (!qrMenu.children.some((c) => c.path === "/qr-code/transfer-amount-setting")) {
            qrMenu.children.push({
              path: "/qr-code/transfer-amount-setting",
              title: "Atur Jumlah Transfer QR",
              is_show_sidebar: 1,
            });
          }
          if (!qrMenu.children.some((c) => c.path === "/qr-code/return-transfer-access")) {
            qrMenu.children.push({
              path: "/qr-code/return-transfer-access",
              title: "Atur Akses Transfer Balik",
              is_show_sidebar: 1,
            });
          }
        }
      }

      this.modules = modules.filter((x) => x.is_show_sidebar == 1);
      // console.log(this.modules)
    },
  },
};
</script>
